import React, { useState, useEffect, Fragment } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import Spinner from '@jumbo/components/custom/Spinner';
import { Edit, Delete, RemoveRedEye, Accessible } from '@material-ui/icons';
import { API_AUTH, ADMIN, SADMIN } from '../../../../../config/config';
import axios from 'axios';
import CreateUser from '../CreateUser';
import UpdateUser from '../UpdateUser';
import DeleteUser from '../DeleteUser';
import UpdateApps from '../UpdateApps';
import { Chip, Box } from '@material-ui/core';
import CustomMenu from '../RolCell';
import { validacionPermit } from '../../../../../services/service.user';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import EnableUserDialog from '../EnableUser';

const styleRol = (content, row) => {
  return (
    <CustomMenu TriggerComponent={<RemoveRedEye />} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Box>
        {(content.findIndex(e => e.name === SADMIN) >= 0 && content.length - 1) ||
        (content.findIndex(e => e.name === SADMIN) < 0 && content.length) ? (
          content.map(item => {
            if (item.name !== SADMIN) {
              return <Chip key={`Chip-${item.name}`} label={item.name} style={{ margin: '4px' }} />;
            } else {
              return null;
            }
          })
        ) : (
          <label style={{ margin: '10px', color: 'red' }}>Sin Roles</label>
        )}
      </Box>
    </CustomMenu>
  );
};

const headCells = [
  { id: 'nombre_completo', label: 'Usuario' },
  { id: 'rutConDv', disablePadding: false, label: 'Rut' },
  { id: 'roles_user', label: 'Roles', style: styleRol },
  { id: 'estado', label: 'Estado' },
];

const actions = () => {
  var res = [];

  if (validacionPermit('create_user')) {
    //aqui hay que usar edit_user pero el rol id 2 administrador no lo trae
    res.push({ action: 'edit', label: 'Modificar datos', icon: <Edit /> });
  }

  if (validacionPermit('create_user')) {
    res.push({
      action: 'editApps',
      label: 'Editar aplicaciones',
      icon: <Delete />,
    });
  }

  if (validacionPermit('create_user')) {
    //aqui hay que usar edit_user pero el rol id 2 administrador no lo trae
    res.push({ action: 'delete', label: 'Deshabilitar', icon: <Delete /> });
  }

  if (validacionPermit('create_user')) {
    //aqui hay que usar edit_user pero el rol id 2 administrador no lo trae
    res.push({ action: 'enable', label: 'Habilitar', icon: <Accessible /> });
  }

  return res.length > 0 ? res : undefined;
};

const TablaUsuarios = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [userList, setUserList] = useState([]);
  const [callUser, setCallUser] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [showUpdateUser, setShowUpdateUser] = useState(false);
  const [userUpdate, setUserUpdate] = useState(null);
  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [showEnable, setShowEnableUser] = useState(false);
  const [userDelete, setUserDelete] = useState(null);
  const [userEnable, setUserEnable] = useState(null);
  const [userData, setUserData] = useState('');
  const [validaciones, setValidaciones] = useState([]);
  const [spinner, setSpinner] = useState(false);

  const [showUpdateApps, setShowUpdateApps] = useState(false);
  const [aplicaciones, setAplicaciones] = useState([]);
  const [organization, setOrganization] = useState('');

  // const classes = useStyles();

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    setUserData(user);

    axios
      .get(`${API_AUTH}organization/${user.organization_id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        },
      })
      .then(res => {
        var rolesAux = [];
        if (res.data.applications.length) {
          res.data.applications.forEach(app => {
            app.roles.forEach(rol => {
              if (rol.name !== ADMIN) {
                rolesAux.push({
                  index: rolesAux.length,
                  label: `${app.name} - ${rol.name}`,
                  id: rol.id,
                });
              }
            });
          });
        }
        setOrganization(res.data);
        setRolesList(rolesAux);
        let auxApps = [{ id: 3, name: 'Administración Extranet', roles: [{ id: 2, name: 'Administrador' }] }];
        res.data.applications.map(app => {
          auxApps.push(app);
          return null;
        });
        setAplicaciones(auxApps);
      })
      .catch(err => {
        console.log(err);
        toast.error('Error al cargar los roles.');
        setSpinner(false);
      });
  }, []);

  useEffect(() => {
    if (userData) {
      axios
        .get(API_AUTH + 'user', {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
          },
        })
        .then(res => {
          const auxUserList = [];
          res.data.forEach(usr => {
            let auxEstado = 'Activo';
            if (usr.is_active !== 1) {
              auxEstado = 'Deshabilitado';
            }
            /* if (!validacionRol('Administrador', usr) || userData.id === usr.id) { */
            auxUserList.push({
              ...usr,
              nombre_completo: `${usr.names} ${usr.last_name} ${usr.mother_last_name ? usr.mother_last_name : ""}`,
              rutConDv: usr.run + '-' + usr.dv,
              estado: auxEstado,
              roles_names: usr.roles_user.map(rol => {
                return rol.name;
              }),
            });
            /*  } */
          });
          setUserList(auxUserList);

          setPrimeraCarga(true);
          setSpinner(false);
        })
        .catch(err => {
          console.log(err);
          toast.error('Error al cargar los usuarios.');
          setSpinner(false);
        })
        .finally(f=>{
          setPrimeraCarga(true)
        });
    }
  }, [callUser, userData]);

  useEffect(() => {
    var auxValidaciones = [];
    if (rolesList.length) {
      var roles = rolesList.map(item => {
        return item.label;
      });
      const item = {
        type: 'select_list',
        target: 'roles_names',
        title: 'Roles',
        options: roles,
      };
      auxValidaciones.push(item);
    }
    setValidaciones(auxValidaciones);
  }, [rolesList]);

  const createUSer = () => {
    setShowCreateUser(true);
  };

  const handleAction = (menu, item) => {
    if (menu.action === 'edit') {
      setUserUpdate(userList.find(e => e.id === item.id));
      setShowUpdateUser(true);

      /*   let auxUsr = userList.find(e => e.id === item.id); */
    } else if (menu.action === 'delete') {
      setShowDeleteUser(true);
      setUserDelete(userList.find(e => e.id === item.id));
    } else if (menu.action === 'enable') {
      setShowEnableUser(true);
      setUserEnable(userList.find(e => e.id === item.id));
    } else if (menu.action === 'editApps') {
      setUserUpdate(userList.find(e => e.id === item.id));
      setShowUpdateApps(true);
    }
  };

  const CreateUserClose = () => {
    setShowCreateUser(false);
  };

  const CreateUserSubmit = () => {
    setSpinner(true);
    setShowCreateUser(false);
    setCallUser(!callUser);
  };

  const UpdateAppsSubmit = () => {
    setCallUser(!callUser);
  };

  const UpdateUserClose = () => {
    setShowUpdateUser(false);
    setUserUpdate(null);
  };

  const CloseUpdateApps = () => {
    setUserUpdate(null)
    setShowUpdateApps(false);
  };

  const UpdateUserSubmit = () => {
    setSpinner(true);
    setShowUpdateUser(false);
    setUserUpdate(null);
    setCallUser(!callUser);
  };

  const DeleteUserClose = () => {
    setShowDeleteUser(false);
    setUserDelete(null);
  };

  const enableUserClose = () => {
    setShowEnableUser(false);
    setUserEnable(false);
  };

  const DeleteUserSubmit = () => {
    setSpinner(true);
    setShowDeleteUser(false);
    setUserDelete(null);
    setCallUser(!callUser);
  };

  const enableUserSubmit = () => {
    setSpinner(true);
    setShowEnableUser(false);
    setUserEnable(null);
    setCallUser(!callUser);
  };

  return (
    validacionPermit('list_user') && (
      <Fragment>
        <CustomToast />
        <Spinner show={spinner} />
        <CreateUser
          openDialog={showCreateUser}
          close={CreateUserClose}
          submit={CreateUserSubmit}
          rolesList={rolesList}
          aplicaciones={aplicaciones}
          organization={organization}
        />
        <UpdateApps
          openDialog={showUpdateApps}
          close={CloseUpdateApps}
          submit={UpdateAppsSubmit}
          rolesList={rolesList}
          userUpdate={userUpdate}
          aplicaciones={aplicaciones}
          organization={organization}
        />
        <UpdateUser
          openDialog={showUpdateUser}
          close={UpdateUserClose}
          submit={UpdateUserSubmit}
          rolesList={rolesList}
          user={userUpdate}
          updateUser={userUpdate}
        />
        <DeleteUser
          openDialog={showDeleteUser}
          close={DeleteUserClose}
          submit={DeleteUserSubmit}
          userDelete={userDelete}
          organization={organization}
        />
        <EnableUserDialog
          openDialog={showEnable}
          close={enableUserClose}
          submit={enableUserSubmit}
          userDelete={userEnable}
          organization={organization}
        />

        {primeraCarga ? (
          <CustomTable
            headCells={headCells}
            rows={userList}
            title={'Usuarios'}
            validation={validaciones}
            search={true}
            actions={actions()}
            handleAction={handleAction}
            add={validacionPermit('create_user') ? createUSer : null}
            addText={'Crear'}
          />
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaUsuarios;
